import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import GAListener from '../../utils/GAListener'
import TopPage from '../pages/Top'
import SearchPage from '../pages/Search'
import ResultPage from '../pages/Result'
import styles from './App.module.scss'

const App: React.FC = () => {
  return (
    <div className={ styles.App }>
      <BrowserRouter>
        <GAListener trackingId={ "UA-155317618-1" }>
          <>
            <Route exact path="/" component={ TopPage } />
            <Route exact path="/search" component={ SearchPage } />
            <Route exact path="/result" component={ ResultPage } />
          </>
        </GAListener>
      </BrowserRouter>
      <div className={ styles.footer }>
        <a href="https://twitter.com/AV_Catcher" target="_blank" rel="noopener">
          運営元
        </a> 
      </div>
    </div>
  );
}

export default App;
